import React, { useEffect } from 'react';

import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { usePFBRoutes } from '@/hooks/usePFBRoutes';
import { RootState } from '@/redux/ducks';
import { sendPageViewEvent } from '@/utils/AnalyticsUtils';
import { setAuthFlowGarfield } from '@/utils/GarfieldUtils';

const UnAuthAppLayout = () => {
	const initializing = useSelector(
		(state: RootState) => state.init.initializing,
	);

	const { data, pathname } = usePFBRoutes();

	useEffect(() => {
		if (!initializing) {
			sendPageViewEvent({
				name: data.pageName || pathname,
				path: pathname,
			});
		}
	}, [pathname, initializing, data.pageName]);

	useEffect(() => {
		setAuthFlowGarfield(false);
	}, []);

	return (
		<>
			<Helmet>
				<link rel="canonical" href={location.origin + location.pathname} />
			</Helmet>
			<Outlet />
		</>
	);
};

export default UnAuthAppLayout;
